"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lowercaseFirstLetter = lowercaseFirstLetter;
exports.uppercaseFirstLetter = uppercaseFirstLetter;
exports.getSnakeCase = getSnakeCase;
exports.getCamelCase = getCamelCase;
exports.getPascalCase = getPascalCase;

function lowercaseFirstLetter(string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

function uppercaseFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
} // Rule: remove punctuations, transform all to lowercase, transform camelCase to snake_case.


function getSnakeCase(string) {
  var punctuationless = string.replace(/[.,/#!$%^&*'";:{}=\-`~()]/g, '');
  var transformed = punctuationless.replace(/[a-z]([A-Z])/g, function (matched) {
    return matched.split('').join('_');
  });
  var snakeCased = transformed.replace(/[^a-z0-9+]/ig, '_');
  var trimmed = snakeCased.replace(/[^a-z0-9+]+$/ig, '');
  return trimmed.toLowerCase();
} // Rule: transform all from space and _ to upperCase, lower first character.


function getCamelCase(string) {
  var uppered = string.replace(/\s(.)|_(.)/g, function (s) {
    return s.toUpperCase();
  });
  var trimmed = uppered.replace(/\s|_/g, '');
  return lowercaseFirstLetter(trimmed);
} // Rule: same as camelCase except first character is upperCase.


function getPascalCase(string) {
  var camelCase = getCamelCase(string);
  return uppercaseFirstLetter(camelCase);
}